import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { AuthContext } from "../Auth/AuthContext";
import { useThemeContext } from "../DarkMode";
import api from "../../services/api";
import { DEFAULT_CHAT_APPEARANCE, resolveChatAppearance } from "../../utils/chatAppearance";

const ChatAppearanceContext = createContext();

export function ChatAppearanceProvider({ children }) {
  const { isAuth } = useContext(AuthContext);
  const { darkMode } = useThemeContext();
  const [preferences, setPreferences] = useState(DEFAULT_CHAT_APPEARANCE);

  const refresh = useCallback(async () => {
    const { data } = await api.get("/crm/chat-appearance");
    setPreferences({ ...DEFAULT_CHAT_APPEARANCE, ...data });
  }, []);

  useEffect(() => {
    if (!isAuth) return undefined;
    refresh().catch(() => undefined);
    const timer = setInterval(() => {
      if (document.visibilityState === "visible") refresh().catch(() => undefined);
    }, 30000);
    return () => clearInterval(timer);
  }, [isAuth, refresh]);

  const saveAppearance = async (next) => {
    const { data } = await api.put("/crm/chat-appearance", next);
    setPreferences({ ...DEFAULT_CHAT_APPEARANCE, ...data });
  };

  return <ChatAppearanceContext.Provider value={{
    preferences,
    appearance: resolveChatAppearance(preferences, darkMode),
    darkMode,
    saveAppearance,
  }}>{children}</ChatAppearanceContext.Provider>;
}

export const useChatAppearance = () => useContext(ChatAppearanceContext);
